import {Component, OnInit, ViewChild} from '@angular/core';
import {PublicService} from '../../../user/service/public.service';
import {Dialog} from '../../../global/util/Dialog';
import {InformType} from '../../../global/util/enum/InformType';
import {CertificateDetailComponent} from '../certificate-detail/certificate-detail.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {TranslateService} from '@ngx-translate/core';
import {PdfJsViewerComponent} from 'ng2-pdfjs-viewer';
import {SessionStorage} from '../../../global/util/SessionStorage';

@Component({
  selector: 'app-document-validator',
  templateUrl: './document-validator.component.html',
  styleUrls: ['./document-validator.component.css']
})
export class DocumentValidatorComponent implements OnInit {
  fileSelected: any;
  loading: boolean;
  operatorsInfo: any[] = [];
  urlStream: any;
  verifySigners = false;
  pdfSrc: any;
  viewIframeContent: boolean;
  @ViewChild('embeddedPdf') embeddedPdf: PdfJsViewerComponent;
  message: string;

  constructor(private publicService: PublicService,
              private modalService: NgbModal,
              private translate: TranslateService) {
  }

  ngOnInit(): void {
    this.message = this.translate.instant('MESSAGE.SELECT-PDF-FILE-CONTAINING-SIGNATURES');
  }

  change(event: any) {
    this.fileSelected = event.target.files[0];
    const reader = new FileReader();
    reader.readAsDataURL(this.fileSelected);
    reader.onload = (e) => {
      const stringBase64: any = e.target.result;
      const base64 = stringBase64.split('base64,');
      SessionStorage.saveUrlPdf(base64[1]);
    };
  }

  validateDocumentPdf() {
    this.loading = true;
    this.verifySigners = true;
    if (this.fileSelected.name) {
      const formData = new FormData();
      formData.append('file', this.fileSelected, this.fileSelected.name);
      this.publicService.validate(formData).subscribe((next: any) => {
        this.loading = false;
        this.operatorsInfo = next.signers;
        this.loadPdfViewer();
        this.verifySigners = false;
        this.viewIframeContent = true;
        if (next.signers.length === 0) {
          Dialog.show(InformType.Info, this.translate.instant('TITLE.VERIFY-SIGNATURES'), this.translate.instant('MESSAGE.THE-DOCUMENT-DOESNT-CONTAIN-SIGNATURES'));
        }
      }, () => {
        this.viewIframeContent = false;
        this.loading = false;
      });
    } else {
      this.verifySigners = false;
      this.loading = false;
    }
  }

  openModalSeeCertificateDetail(index: number) {
    const modalRef = this.modalService.open(CertificateDetailComponent, {size: 'lg'});
    modalRef.componentInstance.operatorInfo = this.operatorsInfo[index];
    modalRef.componentInstance.resumeHashResource = false;
    modalRef.componentInstance.index = index;
    modalRef.componentInstance.haveDocumentIntegrity = false;
    modalRef.componentInstance.downloadValidatorPdf = true;
    modalRef.componentInstance.fileSelected = this.fileSelected;
  }

  get isPresentSigners() {
    return this.operatorsInfo.length > 0;
  }

  public loadPdfViewer() {
    this.loading = true;
    setTimeout(() => {
      this.loading = false;
      this.verifySigners = false;
      this.pdfSrc = SessionStorage.getUrlPdf();
      this.embeddedPdf.pdfSrc = this.pdfSrc;
      this.embeddedPdf.refresh();
    }, 1000);
  }

  invalidSignatures() {
    // tslint:disable-next-line:prefer-for-of
    for (let i = 0; i < this.operatorsInfo.length; i++) {
      return this.operatorsInfo[i].comment;
    }
  }

  getDescription() {
    return this.isModifiedAfterSignature() ? 'Las firmas permanecen íntegras,' +
      ' aunque hay datos adjuntos que no están protegidos por la última firma digital.' : 'La integridad del documento' +
      ' y de sus firmas se conserva.';
  }

  isModifiedAfterSignature(): boolean {
    const lastIndex = this.operatorsInfo.length - 1;
    return this.operatorsInfo[lastIndex].modifiedAfterSignature;
  }
}
